import React, { Component } from "react";
import PropTypes from "prop-types";
import { Highlight, connectAutoComplete } from "react-instantsearch-dom";
import AutoSuggest from "react-autosuggest";
import DefaultProfileImage from "Assets/Images/profile_defaultImg.svg";
import "./index.scss";
import { Link } from "react-router-dom";
import IconLabel from "Component/Labels/IconLabel";
import documentIcon from "Assets/newicons/document/document/outline/document-outline-16px.svg";
import empId from "Assets/Icons/EmployeeId/emp-id-16px.svg";
import Tooltip from "@material-ui/core/Tooltip";
import {
  getMonthName,
  getFormattedImageLink,
  getEJ2CalenderDateFormat,
} from "Utils";
import AssetsIcon from "Assets/newicons/app/assets/outline/assets-outline-16px.svg";
import department from "../../../Assets/Icons/Department/department-16px.svg";
import designation from "../../../Assets/Icons/Designation/designation-16px.svg";

class AutoComplete extends Component {
  static propTypes = {
    hits: PropTypes.arrayOf(PropTypes.object).isRequired,
    currentRefinement: PropTypes.string.isRequired,
    refine: PropTypes.func.isRequired,
    onSuggestionSelected: PropTypes.func.isRequired,
    onSuggestionCleared: PropTypes.func.isRequired,
  };

  state = {
    value: this.props.currentRefinement,
    isTouched: false,

    // suggestions: [],
  };

  onChange = (_, { newValue }) => {
    if (!newValue) {
      this.props.onSuggestionCleared();
    }

    this.setState({
      value: newValue,
    });
  };

  // onBlur(event, { highlightedSuggestion })

  gotoPolicies = () => {};

  onSuggestionsFetchRequested = ({ value }) => {
    this.props.refine(value);
  };

  onSuggestionsClearRequested = () => {
    this.props.refine("");
  };

  blurCallback = (ev) => {
    this.setState({ isTouched: false, value: "" });
  };

  getSuggestionValue(hit) {
    return hit.fullname;
  }

  renderSuggestion(hit, masterprofileid) {
    return (
      <Link to={`/profile/${hit.employeeid}`} target="_blank">
        <div className="search-list-item">
          <div
            className="display-flex"
            style={{ alignItems: "center", justifyContent: "space-between" }}
          >
            <Link to={`/profile/${hit.employeeid}`} target="_blank">
              <div
                className="display-flex"
                style={{ alignItems: "center" }}
                // onClick={localStorage.removeItem("protabvalue")}
                // onClick={localStorage.removeItem("protab")}
              >
                <img
                  src={
                    hit.imagepath != "~"
                      ? getFormattedImageLink(hit.imagepath)
                      : DefaultProfileImage
                  }
                  width="32"
                  height="32"
                  align="left"
                  style={{ borderRadius: 30 }}
                />

                <div className="margin-left-16">
                  <p className="hit-name small-blue t-bold">{hit.fullname}</p>
                  {hit.employeestatus != "null" && (
                    <p
                      className="extra-small-dark-secondary"
                      style={{
                        display: "inline-flex",
                        borderRadius: 20,
                        padding: "1px 8px",
                        border: "1px solid #000",
                        background: "#fff",
                        fontSize: 11,
                      }}
                    >
                      {hit.employeestatus}
                    </p>
                  )}
                </div>
              </div>
            </Link>
            <div className="display-flex">
              {hit.employeecode != "null" && (
                <Tooltip title="Employee code" placement="top">
                  <div style={{ width: 120 }}>
                    <IconLabel
                      label={hit.employeecode}
                      img={empId}
                      labelClassNames="small-dark-secondary width80 ellipsis"
                      iconHeight="16"
                      className="margin-right-16"
                    />
                  </div>
                </Tooltip>
              )}
              {hit.designation != "null" && (
                <Tooltip title="Designation" placement="top">
                  <div style={{ width: 120 }}>
                    <IconLabel
                      label={hit.designation}
                      img={designation}
                      labelClassNames="small-dark-secondary width80 ellipsis"
                      iconHeight="16"
                      className="margin-right-16"
                    />
                  </div>
                </Tooltip>
              )}
              {hit.department != "null" && (
                <Tooltip title="Department" placement="top">
                  <div style={{ width: 120 }}>
                    <IconLabel
                      label={hit.department}
                      img={department}
                      labelClassNames="small-dark-secondary width80 ellipsis"
                      iconHeight="16"
                    />
                  </div>
                </Tooltip>
              )}
            </div>
          </div>

          {masterprofileid == 9 && (
            <div className="margin-top-16 display-flex">
              <div>
                <Link
                  to={{
                    pathname: `/profile/${hit.employeeid}`,
                    hash: "#policies",
                  }}
                  target="_blank"
                >
                  <div
                    className="rounded-rectangle-div inline-block"
                    // onClick={localStorage.setItem("protab", 4)}
                  >
                    <IconLabel
                      label="Policies"
                      img={documentIcon}
                      labelClassNames="small-blue"
                      iconHeight="16"
                    />
                  </div>
                </Link>
              </div>
              <div className="margin-left-16">
                <Link
                  to={{
                    pathname: `/profile/${hit.employeeid}`,
                    hash: "#assets",
                  }}
                  target="_blank"
                >
                  <div
                    className="rounded-rectangle-div inline-block"
                    // onClick={localStorage.setItem("protab", 4)}
                  >
                    <IconLabel
                      label="Assets"
                      img={AssetsIcon}
                      labelClassNames="small-blue"
                      iconHeight="16"
                    />
                  </div>
                </Link>
              </div>
            </div>
          )}
        </div>
      </Link>
    );
  }

  render() {
    const { hits, onSuggestionSelected, placeholder, masterprofileid } =
      this.props;
    const { value, isTouched } = this.state;

    const inputProps = {
      placeholder,
      onChange: this.onChange,
      onBlur: this.blurCallback,
      value: this.state.value,
      type: "search",
    };

    return (
      <AutoSuggest
        inputProps={{
          onChange: this.onChange,
          onBlur: this.blurCallback,

          value: this.state.value,
          type: "search",
          placeholder:
            "Search by employee name, employee code, mobile number or email id..",
        }}
        suggestions={hits}
        onSuggestionsFetchRequested={this.onSuggestionsFetchRequested}
        onSuggestionsClearRequested={this.onSuggestionsClearRequested}
        onSuggestionSelected={onSuggestionSelected}
        getSuggestionValue={this.getSuggestionValue}
        renderSuggestion={(e) => this.renderSuggestion(e, masterprofileid)}
        focusInputOnSuggestionClick={false}
      />
    );
  }
}

export default connectAutoComplete(AutoComplete);
